import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import _ from 'lodash';
import { Button } from 'antd';
import { RootState } from '../../../../../application/store';
import { Product } from '../../../../../api-client';
import { BUSINESS_UNIT_TYPES } from '../../../../../utils/constants/business-unit-types';
import { orderQuantityBySizes } from '../../../../../utils/data-format-enchanters/order-products-enchanter';
import { useProduct } from '../../../../../common/hooks/useProduct';
import './bv-product-card.scss';
import bvProductLimited from '../../../../../assets/images/bv-product-limited.png';
import bvProductNew from '../../../../../assets/images/bv-product-new.svg';
import BVShimmer from '../../../../../common/components/BVShimmers/BVShimmer/bv-shimmer';
import BVProductPrice from '../../../../../common/components/BVProductPrice/bv-product-price';
import BVCompactForm from '../../../ProductsDetailPage/components/BVCompactForm/bv-compact-form';

interface IRouteParams {
    businessUnitCode: string
}

interface IBVProductCard {
    product: Product;
    getHoveredId: Function;
    hoveredProduct: Product | undefined;
    productIndex: number;
    isNewHover: boolean;
}

const BVProductCard: React.FunctionComponent<IBVProductCard> = ({ product, getHoveredId, hoveredProduct, productIndex, isNewHover }) => {
    const {
        handleProductSizes,
        productSizes,
        productSizesLoading,
        handleProductPrice,
        productPrice,
        productPriceLoading
    } = useProduct();

    const history = useHistory();

    useEffect(() => {
        if (product.id === hoveredProduct?.id)
            handleProductSizes(Number(product.id), Number(bvCustomer.id));
    }, [isNewHover])

    const {
        businessUnitCode
    } = useParams<IRouteParams>();

    const bvCustomer = useSelector((state: RootState) => state.customer);
    const bvOrderSummary = useSelector((state: RootState) => state.orderSummary);

    const _handleProductClassName = () => {
        if (!bvOrderSummary || !bvOrderSummary.products) {
            return 'bv-product-card';
        }

        const currentProduct = bvOrderSummary.products.find(entry => entry.id === product.id);

        if (currentProduct) {
            return 'bv-product-card product-card-selected';
        }

        return 'bv-product-card';
    }

    const _handleProductQuantity = () => {
        if (!bvOrderSummary || !bvOrderSummary.products) {
            return null;
        }

        let currentProducts = _.filter(bvOrderSummary.products, entry => entry.id === product.id);
        let currentProductsQuantity = _.map(currentProducts, entry => orderQuantityBySizes(entry.sizes));
        if (currentProductsQuantity && currentProductsQuantity.length > 0) {
            return (
                <div className="product-card-quantity">
                    <span>
                        {_.reduce(currentProductsQuantity, (prev: any, next: any) => prev + next)}
                    </span>
                </div>
            );
        }

        return null;
    }

    const [productPriceHandled, setProductPriceHandled] = useState<boolean>(false);

    return (
        <div
            className={_handleProductClassName()}
            onMouseEnter={() => {
                if (product.id && bvCustomer.id) {
                    setProductPriceHandled(true);

                    !productPriceHandled && handleProductPrice(product.id, bvCustomer.id);
                }
            }}
        >
            {_handleProductQuantity()}

            <div className="product-card-image">
                <img src={product.image?.galleryUrl} alt={product.descrShort} />

                {product.isLimitedEdition &&
                    <img src={bvProductLimited} className="product-limited" alt={product.descrShort} />
                }

                {product.isNovelty &&
                    <img src={bvProductNew} className="product-novelty" alt={product.descrShort} />
                }

                <span className="product-name">
                    <span>
                        {product.descrShort}
                    </span>
                    <span>
                        {businessUnitCode === BUSINESS_UNIT_TYPES.JEWELRY_CODE
                            ? `CatCode: ${product.catalogCode}`
                            : `SapCode: ${product.sapCode}`
                        }
                    </span>
                </span>
            </div>
            <div
                className="product-card-body"
                onMouseEnter={() => getHoveredId(product, productIndex)}
            >
                {
                    product.isMultisize ?
                    <>
                        <div className="product-detail">
                            <div className="detail-wrapper">
                                <span className="heading">
                                    {product.descrShort}
                                </span>
                                <span className="secondary-heading">
                                    {businessUnitCode === BUSINESS_UNIT_TYPES.JEWELRY_CODE
                                        ? `CatCode: ${product.catalogCode}`
                                        : `SapCode: ${product.sapCode}`
                                    }
                                </span>
                            </div>

                            <span className="price-wrapper">
                                <BVShimmer loading={productPriceLoading} type={'shimmer-price'}>
                                    <BVProductPrice
                                        className="bv-product-card-price"
                                        sizes={productPrice ? [productPrice] : []}
                                        isMultisize={product.isMultisize}
                                    />
                                </BVShimmer>
                            </span>
                        </div>

                        <Button type="primary" className="card-btn" onClick={() => history.push(`/catalog/${businessUnitCode}/${product.id}`)}>
                            {'Discover'}
                        </Button>
                    </> :
                    <>
                        <div className="secondary-heading" style={{marginBottom: "10px", fontSize: "13.5px"}}>
                            {businessUnitCode === BUSINESS_UNIT_TYPES.JEWELRY_CODE
                                ? `CatCode: ${product.catalogCode}`
                                : `SapCode: ${product.sapCode}`
                            }
                        </div>

                        <span className="price-wrapper">
                            <BVShimmer loading={productPriceLoading} type={'shimmer-oneline'}>
                                <BVProductPrice
                                    className="bv-product-card-price"
                                    sizes={productPrice ? [productPrice] : []}
                                    isMultisize={product.isMultisize}
                                />
                            </BVShimmer>
                        </span>

                        <BVCompactForm
                            businessUnitCode={businessUnitCode}
                            product={product}
                            productSizes={productSizes}
                            productSizesLoading={productSizesLoading}
                            isEmbedded={true}
                            productIndex={productIndex}
                            isNewHover={isNewHover}
                            hoveredProduct={hoveredProduct}
                        />
                    </>
                }
            </div>
        </div>
    );
}

export default BVProductCard;